import React from "react";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import PersonIcon from "@mui/icons-material/Person";
import { Link } from "react-router-dom";
import StarIcon from "@mui/icons-material/Star";
import Flip from "react-reveal/Flip";
import SchoolIcon from "@mui/icons-material/School";

function ExperienceJourney() {
  return (
    <div className="mt-5">
      <div>
        <Link className="btn btn-primary m-1" to="/educationjourney">
          Educational Journey
        </Link>
        <Link className="btn btn-primary m-1" to="/experiencejourney">
          Experience Journey
        </Link>
        <Link className="btn btn-primary m-1" to="/technicaljourney">
          Technical Journey
        </Link>
        <Link className="btn btn-primary m-1" to="/projectjourney">
          Project Journey
        </Link>
      </div>
      <div className="mt-5">
        <Flip top cascade>
          <h1>Experience Journey</h1>
        </Flip>
      </div>
      <VerticalTimeline>

        {/* Java Internship */}
        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          contentStyle={{ background: "rgb(78 22 112)", color: "#fbd9ad" }}
          contentArrowStyle={{ borderRight: "7px solid  rgb(78 22 112)" }}
          date="Sep 2022 - Feb 2023"
          iconStyle={{ background: "rgb(78 22 112)", color: "#fbd9ad" }}
          icon={<SchoolIcon />}
        >
          <h4 className="vertical-timeline-element-title">Java Full Stack Development Intern</h4>
          <h6 className="vertical-timeline-element-subtitle mt-2">
            Java Full Stack Development – Responsive, Coimbatore, Tamil Nadu, India (On-site)
          </h6>
          <p>
            I have undergone hands-on training in core Java concepts and the Java Spring Framework, gaining practical experience
            in building robust applications. Additionally, I have worked with MongoDB, developing a solid understanding of NoSQL 
            databases and how to integrate them effectively with Java-based applications.
          </p>
        </VerticalTimelineElement>

        {/* Python Internship */}
        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          contentStyle={{ background: "rgb(78 22 112)", color: "#fbd9ad" }}
          contentArrowStyle={{ borderRight: "7px solid  rgb(78 22 112)" }}
          date="Jul 2023 - Dec 2023"
          iconStyle={{ background: "rgb(78 22 112)", color: "#fbd9ad" }}
          icon={<SchoolIcon />}
        >
          <h4 className="vertical-timeline-element-title">Python Full Stack Development Intern</h4>
          <h6 className="vertical-timeline-element-subtitle mt-2">
            Python Full Stack Development – One Team Solutions Edtech Pvt Ltd, Thiruvananthapuram, Kerala, India (On-site)
          </h6>
          <p>
            I have developed web application projects using the Django framework, showcasing strong backend development skills.
            On the front end, I have worked extensively with HTML, CSS, JavaScript, and React.js to build responsive and interactive
            user interfaces. I also have hands-on experience with jQuery and the Bootstrap framework. Additionally, I have used Git with
            GitFlow for version control and Postman for API testing, along with working on MySQL databases.
          </p>
        </VerticalTimelineElement>

        {/* Junior Software Engineer */}
        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          contentStyle={{ background: "rgb(78 22 112)", color: "#fbd9ad" }}
          contentArrowStyle={{ borderRight: "7px solid  rgb(78 22 112)" }}
          date="Jun 2024 - Present"
          iconStyle={{ background: "rgb(78 22 112)", color: "#fbd9ad" }}
          icon={<SchoolIcon />}
        >
          <h4 className="vertical-timeline-element-title">Junior Software Engineer</h4>
          <h6 className="vertical-timeline-element-subtitle mt-2">
            Junior Software Engineer – Scalgo Technologies, Technopark Campus, Thiruvananthapuram, Kerala (On-site)
          </h6>
          <p>
            I have experience developing and implementing backend logic using Python and PHP to ensure robust application functionality.
            I also design and structure user interfaces with HTML, CSS, and JavaScript, using responsive design principles to improve user
            experience. I manage databases like MySQL and MongoDB for efficient data storage and retrieval. As a full-stack developer, I ensure
            seamless front-end and back-end integration. I also optimize performance with efficient queries and algorithms, while debugging and
            resolving issues to maintain high code quality.
          </p>
        </VerticalTimelineElement>

        {/* End Marker */}
        <VerticalTimelineElement
          iconStyle={{ background: "#fbd9ad", color: "rgb(78 22 112)" }}
          icon={<StarIcon />}
        />
      </VerticalTimeline>
    </div>
  );
}

export default ExperienceJourney;
